import React from "react";
import { connect } from "react-redux";
import { getUser } from "../../actions/user/user";
import { FormattedMessage, injectIntl } from "react-intl";
import { login } from "../../actions/authentication/authentication";
import { Offline, Online } from "react-detect-offline";
import Notification from "../sub/Notification";
import Icon from "../sub/Icon";

// import background from './images/background.jpg'
class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      passwordBtn: "eye-slash",
      passwordFieldType: "password",
    };
  }

  // Update fields
  onChange = (field, value) => {
    this.setState({ [field]: value });
  };

  // Allow to unmask the password for verification
  displayPassword = (e) => {
    if (e.type === "mouseover") {
      this.setState({
        passwordBtn: "eye",
        passwordFieldType: "text",
      });
    } else {
      this.setState({
        passwordBtn: "eye-slash",
        passwordFieldType: "password",
      });
    }
  };

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    let that = this;

    const onLoginSuccess = (user) => {
      that.props.history.push("/home/clients");
    };

    const onLoginFail = (error) => {
      switch (error) {
        case "Network Error":
          Notification({
            type: "error",
            description: this.props.intl.formatMessage({ id: "Network.Error" }),
          });
          break;
        case "EmptyCredentials":
          Notification({
            type: "info",
            description: this.props.intl.formatMessage({
              id: "Login.EmptyCredentials",
            }),
          });
          break;
        default:
          Notification({
            type: "error",
            description: this.props.intl.formatMessage({
              id: "Login.Fail",
            }),
          });
          break;
      }
    };

    // Send login information and redirect on success
    this.props.onLogin(
      e.target.email.value,
      e.target.password.value,
      onLoginSuccess,
      onLoginFail,
    );
  }

  // Login form
  displayLoginForm() {
    return (
      <form onSubmit={(e) => this.handleSubmit(e)}>
        <div className="form-group row mt-5">
          <div className="input-group">
            <div className="input-group-prepend">
              <div className="input-group-text bg-light">
                <Icon icon="user" />
              </div>
            </div>
            <input
              type="text"
              id="email"
              name="email"
              className="form-control"
              placeholder={this.props.intl.formatMessage({ id: "Username" })}
              value={this.state.email}
              onChange={(e) => this.onChange(e.target.id, e.target.value)}
              autoComplete="email"
            />
          </div>
        </div>

        <div className="form-group row">
          <div className="input-group">
            <div className="input-group-prepend">
              <div className="input-group-text bg-light">
                <Icon icon="key" />
              </div>
            </div>
            <input
              type={this.state.passwordFieldType}
              className="form-control"
              id="pwd"
              name="password"
              placeholder={this.props.intl.formatMessage({ id: "Password" })}
              autoComplete="current-password"
            />
            <div className="input-group-append">
              <div
                className="btn"
                onMouseOver={(e) => this.displayPassword(e)}
                onMouseOut={(e) => this.displayPassword(e)}
              >
                <Icon icon={this.state.passwordBtn} />
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="m-auto">
            <button type="submit" className="btn btn-info">
              <FormattedMessage id="Connect" />
            </button>
          </div>
        </div>
      </form>
    );
  }

  render() {
    let currentRender;

    if (process.env.REACT_APP_MAINTENANCE_MODE === "true") {
      currentRender = this.setMaintenanceMode();
    } else {
      // User might have been redirected from another URL (e4coll, e4mad or e4vhp). Get jwt and authenticate
      currentRender = this.displayLoginForm();
    }

    return (
      <div className="bg-img">
        <div className="vertical-center no-bg p-0 m-0">
          <div
            className="container pt-5 pl-5 pr-5 pb-0 mw-600"
            style={{ width: "600px" }}
          >
            <img
              className="logo-login"
              alt=""
              height={"250em"}
              src="./images/svg/pharmamad_logo.svg"
            />

            <Offline>
              <div className="alert alert-warning text-center mt-5">
                <Icon icon="warning" className="mb-3" />
                <p>
                  <strong>{<FormattedMessage id="Not.Connected" />}</strong>
                </p>
              </div>
            </Offline>
            <Online>{currentRender}</Online>
          </div>
        </div>
        <div className="text-center text-muted">
          <small>version {process.env.REACT_APP_VERSION}</small>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (username, password, successCallback, failureCallback) =>
      dispatch(login(username, password, successCallback, failureCallback)),

    onGetUser: (callback) => dispatch(getUser(callback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Login));
